export default "/images/vendor/flag-icon-css/flags/4x3/cu.svg?ff35f996902731bad2871a6163a8b426";